export enum PortfolioTimeRange {
  ALL_TIME = "ALL_TIME",
  "30D" = "30D",
  "7D" = "7D",
  "24H" = "24H",
  "1H" = "1H",
}

export const TimeRangeLabels = {
  [PortfolioTimeRange.ALL_TIME]: "All Time",
  [PortfolioTimeRange["7D"]]: "7D",
  [PortfolioTimeRange["30D"]]: "30D",
  [PortfolioTimeRange["24H"]]: "24H",
  [PortfolioTimeRange["1H"]]: "1H",
};

export const COLUMNS_WIDTH = [19, 16, 12, 14, 12, 9, 9, 9];

export enum PortfolioFilterFields {
  tokenPublicKey = "tokenPublicKey",
  totalVolumeUsd = "totalVolumeUsd",
}
